(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */

    let initializeBlock = function( $block ) {

        let tabs     = $block.find('.nav-team__link');
        let slider   = $block.find('.slider-team');
        let slide    = $block.find('.slide-team');
        let controls = $block.find('.slider-controls');

        let sliderSettings = {
            slide       : '.slide-team',
            rows        : 0,                            // fix bug to make slide param works (https://stackoverflow.com/questions/30036742/jquery-slick-carousel-slide-setting)
            arrows      : true,
            appendArrows: $(controls),
            prevArrow   : $block.find('.slick-prev'),
            nextArrow   : $block.find('.slick-next'),
            speed       : 500,
            cssEase     : 'ease-in-out',
            infinite    : false,
            draggable    : false,
            slidesToShow: 5,
            slidesToScroll: 5,

            responsive: [
                {
                    breakpoint: 1151,
                    settings  : {
                        slidesToShow : 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 851,
                    settings  : {
                        slidesToShow : 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 641,
                    settings  : {
                        speed         : 250,
                        cssEase       : 'ease-out',
                        touchThreshold: 12,
                        slidesToShow  : 2,
                        slidesToScroll: 2,
                        draggable     : true,
                    }
                },
                {
                    breakpoint: 501,
                    settings  : {
                        speed         : 250,
                        cssEase       : 'ease-out',
                        touchThreshold: 12,
                        slidesToShow  : 1,
                        slidesToScroll: 1,
                        centerMode    : true,
                        centerPadding : '50px',
                        draggable     : true,
                    }
                },
            ],
        };

        // Filtre les slides en fonction de la tab active après l'initialisation
        function filterSlideByActiveTab(tab, $slick) {
            if(!tab.classList.contains('is-active')) return false;
            tab.term = { id: tab.getAttribute('data-term') };

            $slick.slick('slickUnfilter');
            if (tab.term.id != -1) $slick.slick('slickFilter',`[data-term=${tab.term.id}]`);
        };

        if ($(slide).length > 1) {
            $(slider).slick(sliderSettings);
            tabs.each((i, tab) => filterSlideByActiveTab(tab, $(slider)));
        }

        // Slider filter with term
        $(document).on('click', '.nav-team__link', function(e) {
            e.preventDefault();

            $('.nav-team__link.is-active').removeClass('is-active');
            $(this).addClass('is-active');

            let termId = $(this).data('term');
            
            // unfilter first
            $(slider).slick('slickUnfilter');
            closeInfo(e, false);
            // filter by term id
            if (termId != -1) {
                $(slider).slick('slickFilter',`[data-term=${termId}]`);
                AOS.init();
            }    
        });

        
        //        Show / Hide infos
        // ==============================================

        let block        = $block[0];
        let infosWrapper = block.querySelector('.infos-wrapper');
        let header       = document.getElementById('header');
        let headerHeight = (header) ? header.offsetHeight : 0;

        // Smooth scroll to anchor
        function scrollToNav(hash, offset=0, delay=0) {
            offset -= headerHeight;
            
            let target  = block.querySelector(hash);
            let targetY = target.offsetTop + offset;

            // calculate scroll speed according to the distance between current position and target
            let scrolled    = window.pageYOffset;
            let scrollDelta = Math.abs(target.offsetTop - scrolled);
            let scrollSpeed = Math.floor(scrollDelta / 1.2);
                scrollSpeed = Math.min(Math.max(scrollSpeed, 800), 1600);
            // console.log('target.offsetTop / scrolled', target.offsetTop, scrolled, scrollDelta, '->', scrollSpeed);

            $('body,html').delay(delay).animate({ scrollTop : targetY }, scrollSpeed, 'easeInOutCubic', function(){  });
        }

        
        // open / close item infos
        function clickItem(e) {
            e.preventDefault();
            
            // open
            if(!this.classList.contains('is-active')) {
                closeLastItem();
                
                this.classList.add('is-active');
                
                let currentContent = block.querySelector(`.info-content[data-id="${this.dataset.id}"]`);
                currentContent.classList.add('is-active');
                
                let contentH;
                if(window.innerWidth > 640) {
                    contentH = currentContent.scrollHeight;
                    scrollToNav('.infos-wrapper');
                } else {
                    contentH = window.innerHeight - headerHeight;
                    document.body.classList.add('no-scroll');
                }
                // console.log('contentH', contentH);
                infosWrapper.style.setProperty('--current-height', contentH+'px');

            // close    
            } else {
                closeInfo(e);
            }
        }    
    

        // close info and deselect last item opened
        function closeInfo(e, scrollToPosition=true) {
            closeLastItem();
            infosWrapper.style.setProperty('--current-height', 0);     
            document.body.classList.remove('no-scroll');
            if(window.innerWidth > 640 && scrollToPosition) scrollToNav('.slider-team__wrapper');   
        } 

        // deselect last item opened
        function closeLastItem() {
            block.querySelectorAll('.slide-team__link.is-active').forEach( function( el ) {
                el.classList.remove('is-active');
            });
            block.querySelectorAll('.info-content.is-active').forEach( function( el ) {
                el.classList.remove('is-active');
                el.classList.add('trans-out');      // slide out last info and remove class after animation
                el.addEventListener('animationend', onInfoClosed);
            });
        }

        // transition end for last item opened
        function onInfoClosed(e) {
            e.target.classList.remove('trans-out');
        }
    
        
        // block.querySelectorAll('.slide-team__link').forEach( function( el ) {
        //     el.addEventListener('click', clickItem);
        // });
        $(document).on('click', '.slide-team__link', clickItem);
        
        block.querySelector('.btn-close').addEventListener('click', closeInfo);


        window.addEventListener('resize', function() {
            let currentContent = block.querySelector('.info-content.is-active');
            if (currentContent) {
                let contentH;
                if(window.innerWidth > 640) {
                    contentH = currentContent.scrollHeight;
                } else {
                    contentH = window.innerHeight - headerHeight;
                }

                if (infosWrapper.style.getPropertyValue('--current-height') != contentH+'px') {
                    infosWrapper.style.setProperty('--current-height', contentH+'px');
                }
            }
        });
    }



    //        Init blocks in front and admin editor
    // ==============================================

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.block-team').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=team', initializeBlock );
    }

})(jQuery);